// 考勤记录
import http from "@/promise/http";
const CONTROLLER_NAME = "/attendance/";

// 列表信息
export const postListPage = (pageNum, numPerPage, params) => {
  return http.post(CONTROLLER_NAME.concat("listPage"), {
    pageNum: pageNum,
    numPerPage: numPerPage,
    condition: params,
  });
};

//在线考勤
export const attendanceSupplement = (infoForm) => {
  return http.post(CONTROLLER_NAME.concat("attendanceSupplement"), infoForm);
};
